export class Node<T> {
    data: T;
    next: Node<T> | null = null;

    constructor(data: T) {
        this.data = data;
    }
}

export class LinkedList<T> {
    head: Node<T> | null = null;
    comparator: (a: T, b: T) => boolean;

    constructor(comparator: (a: T, b: T) => boolean) {
        this.comparator = comparator;
    }

    insertAt(data: T, index: number): void {
        if (!this.head) {
            this.head = new Node(data);
            return;
        }

        if (index === 0) {
            this.head = new Node(data);
            return;
        }

        let counter = 0;
        let current = this.head;
        while (current.next) {
            if (counter === index - 1) {
                const node = new Node(data);
                node.next = current.next;
                current.next = node;
                return;
            }

            current = current.next;
            counter++;
        }

        current.next = new Node(data);
    }

    append(data: T): void {
        if (!this.head) {
            this.head = new Node(data);
        } else {
            let current = this.head;
            while (current.next != null) {
                current = current.next;
            }
            current.next = new Node(data);
        }
    }

    delete(data: T): void {
        if (!this.head) return;

        // Check if the head node is the node to be removed
        if (this.comparator(this.head.data, data)) {
            this.head = this.head.next;
            return;
        }

        let current = this.head.next;
        let previous = this.head;

        /**
         * Search for the node to be removed and keep track of its previous node
         *
         * If it were a double linked list, we could simply search the node
         * and it would have a pointer to the previous node
         **/
        while (current) {
            if (this.comparator(current.data, data)) {
                current = null;
            } else {
                previous = current;
                current = current.next;
            }
        }

        /**
         * set previous.next to the target.next, if the node target is not found,
         * the 'previous' will point to the last node,
         * since the last node hasn't next, nothing will happen
         **/
        previous.next = previous.next ? previous.next.next : null;
    }

    search(data: T): Node<T> | null {
        let current = this.head;
        while (current) {
            if (this.comparator(current.data, data)) {
                return current;
            }
            current = current.next;
        }
        return null;
    }

    searchByName(data: string): Node<T> | null {
        let current = this.head;
        while (current) {
            if (Object.prototype.hasOwnProperty.call(current.data, 'name') && (current.data as any)['name'] === data) {
                return current;
            }
            current = current.next;
        }
        return null;
    }

    searchByNameIndex(data: string): number | null {
        let index = 0;
        let current = this.head;
        while (current) {
            if (Object.prototype.hasOwnProperty.call(current.data, 'name') && (current.data as any)['name'] === data) {
                return index;
            }
            current = current.next;
            index++;
        }
        return null;
    }
    
    traverse() {
        let current = this.head;
        while (current != null) {
            current = current.next;
        }
    }

    obtainArray(): T[] {
        let current = this.head;
        let array = [];
        while (current != null) {
            array.push(current.data);
            current = current.next;
        }
        return array;
    }
}